export default {
  path: 'payment',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "payment-layout" */ '@/modules/payment/PaymentLayout.vue'
    ),
  children: [
    {
      path: 'transactions',
      name: 'PaymentTransaction',
      component: () =>
        import(
          /* webpackChunkName: "payment-transaction" */ '@/modules/payment/views/Transactions'
        )
    }
  ]
}
